import gaotieAPI from './gaotie-api';
import hosts from '../hosts';

//extend params: addCommonParams, urlBase
export default function(options) {
  return Promise.resolve().then(() => {
    if (options.addCommonParams) {
      return gaotieAPI.getCommonParams()
    }
  }).then(commonParams => {
    commonParams = commonParams || {}
    const data = {
      ...commonParams,
      ...options.data
    };

    if (options.sidFields && options.sidFields.length > 0) {
      data.sid = gaotieAPI.generateSid(options.sidFields, data);
    }

    const headers = Object.assign({
      'content-type': 'application/x-www-form-urlencoded'
    }, options.headers);

    return {
      url: hosts.gaotie[options.urlBase || 'train'] + options.url,
      method: options.method,
      headers,
      data
    };
  });
}



// WEBPACK FOOTER //
// ./src/request/transformers/gaotie.js